import { render, staticRenderFns } from "./newdashboard.vue?vue&type=template&id=e807f1c4&scoped=true"
import script from "./newdashboard.vue?vue&type=script&lang=js"
export * from "./newdashboard.vue?vue&type=script&lang=js"
import style0 from "./newdashboard.vue?vue&type=style&index=0&id=e807f1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e807f1c4",
  null
  
)

export default component.exports